import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface SnomedSearchResponse {
  codes: { code: string; display: string; system: string }[];
}

export const useSnomedSearch = ({
  searchTerm,
  eclExpression,
}: {
  searchTerm: string;
  eclExpression: string;
}) => {
  return useApi<SnomedSearchResponse>({
    queryOptions: {
      enabled: !!searchTerm && searchTerm.length > 2,
      queryFn: async () => {
        const response = await axiosInstance.get<SnomedSearchResponse>(
          "/ontology/codes/snomed/search",
          {
            params: {
              searchTerm,
              eclExpression,
            },
          },
        );

        return response.data;
      },
      queryKey: QueryKeys.Snomed.SEARCH(searchTerm),
    },
  });
};
